import type { UserMiniEntity } from '@/features/user/domain/entities/UserMiniEntity'
import type { DriverStatus } from '../enums/DriverStatus'
import type { RegionEntity } from '@/features/region/domain/entities/RegionEntity'
import type { LngLatEntity } from '@/shared/entities/LngLatEntity'
import type { VehicleTemplateEntity } from '@/features/vehicleTemplate/domain/entities/VehicleTemplateEntity'
import type { DriverTeamEntity } from '@/features/driverTeam/domain/entities/DriverTeamEntity'
import type { DriverOrderSupportType } from '../enums/DriverOrderSupportType'
import type { DayOfWeek } from '@/shared/enums/DayOfWeekEnum'

export class DriverEntity {
  id?: number
  userId?: string
  user?: UserMiniEntity
  pouchId?: number
  workingPhoneNumber?: string | null
  fullName?: string | null
  avatarImagePath?: string | null
  region?: RegionEntity
  status?: DriverStatus
  currentStatus?: DriverStatus
  numberOfShipmentHave?: number
  vehicleSize?: number
  currentLocation?: LngLatEntity
  averageScore?: number
  vehicleTemplate?: VehicleTemplateEntity
  vehicleTemplateName?: string
  vehicleTemplateType?: string
  createdAt?: string
  driverTeams?: DriverTeamEntity[]
  orderSupportTypes?: DriverOrderSupportType[]
  defaultDayOff?: DayOfWeek | null
}
